export const config = {
  title: 'Add Notes & Share',
  okText: 'Save & Share',
  width: 480,
  fields: [
    {
      name: 'notes',
      label: 'Notes',
      type: 'mention-textarea',
      required: true,
      rows: 5,
      // Enforced by the browser AND re-checked at submit (see MentionField and
      // securityValidationRule, which reads this same key) so a pasted value
      // cannot slip past the input cap. Script/HTML/SQL content is rejected by
      // that shared rule too — one engine, same rules as every form field.
      maxLength: 2000,
      placeholder: "Add your notes on the job. Use '@' to mention someone.",
      mentionFetchKey: 'mentionUsers',
    },
  ],
};
